export default "__VITE_ASSET__7EhfBTrY__"